<label 
  *ngIf="labelText" 
  [htmlFor]="id"
  [ngClass]="isDisabled ? 'eq-form-label-top--disabled' : ''"
>
  {{ labelText }}
</label>
<select
  *ngIf="!_isPlatformServer && _isPlatformBrowser"
  [name]="name"
  [id]="id"
  class="eq-form-select select-showcase"
  [required]="isRequired"
  [disabled]="isDisabled"
>
  <option *ngIf="hasPlaceholder" value="" disabled selected hidden>
    {{placeholderLabel}}
  </option>
  <option *ngFor="let option of options" value="{{ option.value }}">
    {{ option.text }}
  </option>
</select>
<small *ngIf="error" class="eq-text-sm eq-mt-2 eq-text-red-brandRed-hover">{{ errorText }}</small>
